/**
 * The scheduler's real state on this deployment (GET /reports/scheduled/status).
 *
 * Scheduled generation, delivery and the SLA digest all ship switched off, and
 * nothing on screen said so: a schedule showed a next-run time on a deployment
 * where no schedule ever runs (REG-05).
 */
import { useQuery } from '@tanstack/react-query'
import { reportSchedulesService, type ReportSchedulerStatus } from '@/services/reportSchedules'

export const SCHEDULER_STATUS_QUERY_KEY = ['report-scheduler-status'] as const

export function useSchedulerStatus() {
  return useQuery({
    queryKey: SCHEDULER_STATUS_QUERY_KEY,
    queryFn: () => reportSchedulesService.getStatus(),
    staleTime: 60_000,
    retry: false,
  })
}

/** The next-run text for a schedule, honest about a scheduler that is off. */
export function nextRunText(
  status: ReportSchedulerStatus | undefined,
  nextRunAt: string | null | undefined,
  format: (iso: string | null | undefined) => string,
): string {
  if (status && !status.generationEnabled) return 'Not scheduled — generation is off on this deployment'
  return format(nextRunAt)
}
